import { cn } from '@change/ds-utils';

type Props = {
	children: React.ReactNode;
	className?: string;
};

export function ToastBanner({ children, className, ...rest }: Props): JSX.Element {
	return (
		<div className={cn('flex w-full gap-4', className)} {...rest}>
			{children}
		</div>
	);
}
